(() => {
  const section = document.querySelector('.iis-future');
  if (!section) return;
  const answer = section.querySelector('.future-answer');
  const scene = section.querySelector('.future-scene');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (scene && !reduced.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        scene.classList.add('scene-enter');
        observer.disconnect();
      }
    }, {threshold: .2});
    observer.observe(scene);
    scene.addEventListener('animationend', event => {
      if (event.animationName === 'world-enter') scene.classList.remove('scene-enter');
    });
  }
  if (scene && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced.matches) {
    let frame;
    scene.addEventListener('pointermove', event => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = scene.getBoundingClientRect();
        scene.style.setProperty('--scene-x', `${-((event.clientY - rect.top) / rect.height - .5) * 5}deg`);
        scene.style.setProperty('--scene-y', `${((event.clientX - rect.left) / rect.width - .5) * 6}deg`);
      });
    });
    scene.addEventListener('pointerleave', () => {
      cancelAnimationFrame(frame);
      scene.style.removeProperty('--scene-x');
      scene.style.removeProperty('--scene-y');
    });
  }
  const content = {
    lavoro: ['Presentati con una candidatura chiara.', 'Raccogli esperienze, competenze e allegati. Adatta il CV alla posizione e preparati a spiegare cosa puoi portare all’azienda.', 'Inizia dalla guida al CV', 'blog-cv-svizzero.html'],
    casa: ['Cerca una casa con un piano concreto.', 'Definisci budget, zona e collegamenti. Prepara il dossier per l’affitto e annota le domande da fare durante ogni visita.', 'Leggi la guida alla ricerca della casa', 'blog-casa-zurigo.html'],
    vita: ['Dai spazio anche alla vita di tutti i giorni.', 'Informati sulla lingua della zona, esplora il quartiere e cerca attività in cui conoscere persone. Organizza le priorità senza voler risolvere tutto in un giorno.', 'Esplora il percorso del trasferimento', '#roadmap']
  };
  section.querySelectorAll('[data-future]').forEach(button => {
    button.addEventListener('click', () => {
      if (button.getAttribute('aria-pressed') === 'true') return;
      section.querySelectorAll('[data-future]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const [title, text, label, href] = content[button.dataset.future];
      if (scene) scene.dataset.focus = button.dataset.future;
      answer.querySelector('h3').textContent = title;
      answer.querySelector('p').textContent = text;
      const link = answer.querySelector('a');
      link.href = href;
      link.replaceChildren(document.createTextNode(label + ' '));
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.append(arrow);
      answer.classList.remove('is-changing');
      void answer.offsetWidth;
      answer.classList.add('is-changing');
    });
  });
})();
